import React from 'react';
import * as Styles from './FlowFinished.styles';
import { Button, IconArrow, IconCircleCheck } from 'gatorcomponents';

const FlowFinished = ({
  SnappyImage,
  button,
  locale,
  newDomain,
  mobile,
  icon = <IconCircleCheck color="primaryBlue" />,
}) => (
  <Styles.ComponentWrapper data-testid="flow-finished">
    <Styles.HeadWrapper>
      <Styles.IconCircle>
        {icon}
      </Styles.IconCircle>
      <Styles.Wrapper>
        <Styles.Title>
          {typeof locale.title === 'function' ? locale.title(newDomain) : locale.title}
        </Styles.Title>
        <Styles.Description>
          {locale.description}
        </Styles.Description>
      </Styles.Wrapper>
    </Styles.HeadWrapper>
    {SnappyImage && (
      <Styles.ImageWrapper>
        <Styles.Image src={SnappyImage} alt="Imagem Snappy" />
      </Styles.ImageWrapper>
    )}
    {locale.helpLabel && (
      <Styles.HelpLabel>
        {locale.helpLabel}
      </Styles.HelpLabel>
    )}
    <Styles.ButtonsWrapper>
      <Styles.ButtonContainer>
        {button && (
          <Button
            label={button.label}
            variant={button.variant}
            width={mobile ? 'full' : 'fit'}
            size="medium2"
            iconRight={button.iconRight && <IconArrow direction="right" />}
            onClick={button.action}
            testId="back-button"
          />
        )}
      </Styles.ButtonContainer>
    </Styles.ButtonsWrapper>
  </Styles.ComponentWrapper>
);

export default FlowFinished;
